/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Country,
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
} from './Country';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    addressId?: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    addressRow1?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    addressRow2?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    contactNumber?: string;
    /**
     * 
     * @type {Country}
     * @memberof Address
     */
    countryByCountryId?: Country;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    countryId?: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    isDefault?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    phoneCountryId?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    recipient?: string;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addressId': !exists(json, 'addressId') ? undefined : json['addressId'],
        'addressRow1': !exists(json, 'addressRow1') ? undefined : json['addressRow1'],
        'addressRow2': !exists(json, 'addressRow2') ? undefined : json['addressRow2'],
        'contactNumber': !exists(json, 'contactNumber') ? undefined : json['contactNumber'],
        'countryByCountryId': !exists(json, 'countryByCountryId') ? undefined : CountryFromJSON(json['countryByCountryId']),
        'countryId': !exists(json, 'countryId') ? undefined : json['countryId'],
        'isDefault': !exists(json, 'isDefault') ? undefined : json['isDefault'],
        'phoneCountryId': !exists(json, 'phoneCountryId') ? undefined : json['phoneCountryId'],
        'recipient': !exists(json, 'recipient') ? undefined : json['recipient'],
    };
}

export function AddressToJSON(value?: Address | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addressId': value.addressId,
        'addressRow1': value.addressRow1,
        'addressRow2': value.addressRow2,
        'contactNumber': value.contactNumber,
        'countryByCountryId': CountryToJSON(value.countryByCountryId),
        'countryId': value.countryId,
        'isDefault': value.isDefault,
        'phoneCountryId': value.phoneCountryId,
        'recipient': value.recipient,
    };
}

